import React, { useEffect, useState, useMemo, useRef } from "react";
import moment from "moment";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
} from "@mui/material";
import StoreSearch from "../../../Campaign/StoreSearch.js";
import Decrypt from "../../../../../shared/utils/Decrypt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import styles from "../../JobBatch.module.css";
import PdfIcon from "../../../../../shared/assets/icons/PdfIcon.png";
import ModalToUpdateBatches from "../../ModalToUpdateBatches";
import axios from "axios";

const Completed = ({
  id,
  isAllBatchesLoading,
  forbatch,
  // acceptedBatches,
  // setAcceptedBatches,
  setTotalCompletedBatches,
}) => {
  const [expandedBatch, setExpandedBatch] = React.useState(null);
  const [openModalToUpdateBatch, setOpenModalToUpdateBatch] =
    React.useState(false);
  const [detailsOfBatchSelected, setDetailsOfBatchSelected] = React.useState();

  const [completedBatches, setCompletedBatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const batchRefs = useRef({});
  const containerRef = useRef(null);

  const fetchCompletedBatchBasedOnCampaignId = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token not found in localStorage");
        setCompletedBatches([]);
        setTotalCompletedBatches(0);
        return;
      }

      const { data } = await axios.get(
        `${
          process.env.REACT_APP_URL
        }/jobs/completedBatchesForRecce?campaignId=${id}&serviceType=${0}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (data?.success && Array.isArray(data.data)) {
        // Add dateRange to each batch
        const updatedBatches = data.data.map((batch) => {
          if (batch.jobs && batch.jobs.length > 0) {
            const jobDates = batch.jobs.map(
              (job) => new Date(job.jobStartingDate),
            );
            const completionDates = batch.jobs.map(
              (job) => new Date(job.jobCompletionDate),
            );
            const earliestDate = new Date(
              Math.min(...jobDates.map((date) => date.getTime())),
            );
            const latestDate = new Date(
              Math.max(...completionDates.map((date) => date.getTime())),
            );
            batch.dateRange = `${earliestDate.toLocaleDateString()} - ${latestDate.toLocaleDateString()}`;
          } else {
            batch.dateRange = "No Dates Available";
          }
          return batch;
        });

        setCompletedBatches(updatedBatches);
        setTotalCompletedBatches(updatedBatches.length);
      } else {
        console.warn("Unexpected API response", data);
        setCompletedBatches([]);
        setTotalCompletedBatches(0);
      }
    } catch (error) {
      console.error("Error while fetching jobs", error);
      setCompletedBatches([]);
      setTotalCompletedBatches(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompletedBatchBasedOnCampaignId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleAccordionToggle = (batchTitle) => (event) => {
    event.stopPropagation();
    setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  };

  // Handle the logic to update batches with jobs
  // useEffect(() => {
  //   if (forbatch && acceptedBatches.length > 0) {
  //     const updatedBatches = acceptedBatches.map((batch) => ({
  //       ...batch,
  //       jobs: [],
  //       totalPayment: 0, // Initialize total payment
  //     }));

  //     forbatch.forEach((job) => {
  //       const batch = updatedBatches.find(
  //         (batch) => batch._id === job.batchOfJobsForInstallationPartnerId
  //       );
  //       if (batch) {
  //         batch.jobs.push(job);
  //       }
  //     });

  //     // Calculate total payment and date range for each batch
  //     updatedBatches.forEach((batch) => {
  //       if (batch.jobs.length > 0) {
  //         const jobDates = batch.jobs.map(
  //           (job) => new Date(job.jobStartingDate)
  //         );
  //         const completionDates = batch.jobs.map(
  //           (job) => new Date(job.jobCompletionDate)
  //         );

  //         const earliestDate = new Date(
  //           Math.min(...jobDates.map((date) => date.getTime()))
  //         );
  //         const latestDate = new Date(
  //           Math.max(...completionDates.map((date) => date.getTime()))
  //         );

  //         batch.dateRange = `${earliestDate.toLocaleDateString()} - ${latestDate.toLocaleDateString()}`;

  //         // Calculate total payment
  //         batch.totalPayment = batch.jobs.reduce(
  //           (sum, job) => sum + job.paymentAmount,
  //           0
  //         );
  //       } else {
  //         batch.dateRange = "No Dates Available";
  //       }
  //     });

  //     setAcceptedBatches((prevBatches) => {
  //       const prevBatchesString = JSON.stringify(prevBatches);
  //       const updatedBatchesString = JSON.stringify(updatedBatches);

  //       if (prevBatchesString !== updatedBatchesString) {
  //         return updatedBatches;
  //       } else {
  //         return prevBatches;
  //       }
  //     });

  //     // Update total completed batches count
  //     const completedBatchesCount = updatedBatches.filter((batch) =>
  //       batch.jobs.every((job) => job.status === 2)
  //     ).length;
  //     setTotalCompletedBatches(completedBatchesCount);
  //   }
  // }, [forbatch, acceptedBatches, setAcceptedBatches, setTotalCompletedBatches]);

  const searchData = useMemo(() => {
    const result = [];

    completedBatches.forEach((batch) => {
      batch.jobs?.forEach((job) => {
        result.push({
          id: job._id,
          storeName: job.storeName,
          batchTitle: batch.batchTitle,
          targetId: batch._id,
          subText: `Batch: ${batch.batchTitle}`,
        });
      });
    });

    return result;
  }, [completedBatches]);

  return (
    <Grid ref={containerRef} className={`${styles.scrollableContainer}`}>
      <div
        className="mx-3 py-2 sticky top-0 z-20 bg-white"
        
      >
        <StoreSearch
          data={searchData}
          searchKey="storeName"
          placeholder="Search Store Name"
          containerRef={containerRef}
          targetRefs={batchRefs}
          onSelect={(item) => {
            setExpandedBatch(item.batchTitle);
          }}
        />
      </div>
      {loading ? (
        <div className={styles.noJobsStyle}>
          <CircularProgress />
        </div>
      ) : completedBatches?.filter((batch) =>
          batch.jobs?.every((job) => job?.status === 2),
        ).length > 0 ? (
        completedBatches
          ?.filter((batch) => batch?.jobs?.every((job) => job?.status === 2)) // Filter out batches with pending jobs
          .map((batch, index) => (
            <Grid
              ref={(el) => (batchRefs.current[batch._id] = el)}
              item
              xs={12}
              md={12}
              key={index}
              my={1}
              mx={2}
            >
              <Accordion expanded={expandedBatch === batch?.batchTitle}>
                <AccordionSummary
                  expandIcon={
                    <IconButton
                      onClick={handleAccordionToggle(batch?.batchTitle)}
                    >
                      <ExpandMoreIcon />
                    </IconButton>
                  }
                  aria-controls={`panel-${index}-content`}
                  id={`panel-${index}-header`}
                >
                  <div className="flex items-center justify-between p-4 rounded-lg bg-white w-full mx-auto">
                    {/* Section 1: Batch Title */}
                    <div className="flex">
                      <h1 className={`${styles.batchTitle}`}>
                        {batch?.batchTitle}
                      </h1>
                    </div>

                    {/* Section 2: Other Details */}
                    <div className={styles.chipContainer}>
                      <div>
                        <Chip
                          label={`Timeline: ${moment(
                            batch?.jobStartingDate,
                          ).format("DD MMM YY")} - ${moment(
                            batch?.jobCompletionDate,
                          ).format("DD MMM YY")}`}
                          className={styles.chip}
                        />
                      </div>

                      <Chip
                        key={index}
                        label={
                          batch?.installationPartnerId
                            ? `${batch?.installationPartnerId?.name} - ${
                                Decrypt(
                                  batch?.installationPartnerId?.phoneNumber,
                                ) || "N/A"
                              }`
                            : "No Contact Info"
                        }
                        className={styles.chip}
                      />

                      {/* Display Total Payment */}
                      <Chip
                        label={
                          <span>Batch Payment: ₹{batch?.paymentAmount}</span>
                        }
                        className={styles.chips}
                      />

                      {/* Status Badge */}
                      {batch?.jobs?.every((job) => job?.status === 2) && (
                        <Chip label="Complete" className={styles.amountPaid} />
                      )}
                      <Chip
                        label={"Jobs:" + batch.jobs?.length || 0}
                        className={styles.chip}
                      />
                      {/* Ellipsis Button */}
                      {/* <button
                        className="text-gray-400 hover:text-gray-600 text-xl rounded-full px-4 py-1 hover:bg-gray-100"
                        onClick={() => {
                          setOpenModalToUpdateBatch(true);
                          setDetailsOfBatchSelected(batch);
                        }}
                      >
                        ⋮
                      </button> */}
                    </div>
                  </div>
                </AccordionSummary>

                <AccordionDetails className={styles.accordionDetails}>
                  {/* Render Job Details Table */}
                  <Box className={`${styles.scrollableBox}`}>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow className={styles.tableHeader}>
                            <TableCell className={styles.tableCell}>
                              ADDRESS
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              STORE MANAGER
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              PRODUCT TYPE
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              JOB PAY
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              KAM APPROVAL
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              CLIENT APPROVAL
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              JOB STATUS
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              IP PAY
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {batch?.jobs?.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  <span>{row.storeName}</span> {/*store name */}
                                </div>
                                <div className={styles.address2}>
                                  <span>{row.city}</span>,{" "}
                                  <span>{row.state}</span>,{" "}
                                  <span>{row.zipCode}</span>
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.storeOwnerName}
                                </div>
                                <div className={styles.storeManagerContact}>
                                  {row.storeOwnerPhoneNumber}
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row?.productId?.productType || "N/A"}
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  ₹{row.paymentAmount}
                                </div>
                              </TableCell>

                              {/* KAM Approval */}
                              <TableCell className={styles.tableCell}>
                                <Chip
                                  label={
                                    row?.jobApprovalStatus?.adminStatus === 1
                                      ? "Approved"
                                      : row?.jobApprovalStatus?.adminStatus ===
                                          -1
                                        ? "Rejected"
                                        : "Pending"
                                  }
                                  className={
                                    row?.jobApprovalStatus?.adminStatus === 1
                                      ? styles.amountPaid
                                      : row?.jobApprovalStatus?.adminStatus ===
                                          -1
                                        ? styles.blacklisted
                                        : styles.pending
                                  }
                                />
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <Chip
                                  label={
                                    row?.jobApprovalStatus?.clientStatus === 1
                                      ? "Approved"
                                      : row?.jobApprovalStatus?.clientStatus ===
                                          -1
                                        ? "Rejected"
                                        : row?.jobApprovalStatus
                                              ?.clientStatus === 2
                                          ? "Hold On"
                                          : "Pending"
                                  }
                                  className={
                                    row?.jobApprovalStatus?.clientStatus === 1
                                      ? styles.amountPaid
                                      : row?.jobApprovalStatus?.clientStatus ===
                                          -1
                                        ? styles.rejected
                                        : row?.jobApprovalStatus
                                              ?.clientStatus === 2
                                          ? styles.holdon
                                          : styles.pending
                                  }
                                />
                              </TableCell>

                              <TableCell className={styles.tableCell}>
                                <Chip
                                  label={
                                    row.status === 0
                                      ? "Pending"
                                      : row.status === 2
                                        ? "Complete"
                                        : row.status
                                  }
                                  className={
                                    row.status === 2
                                      ? styles.amountPaid
                                      : row.status === 0
                                        ? styles.pending
                                        : ""
                                  }
                                />
                              </TableCell>

                              <TableCell className={styles.tableCell}>
                                <Chip
                                  label={
                                    row.paymentCredited ? "Paid" : "Pending"
                                  }
                                  className={
                                    row.paymentCredited
                                      ? styles.amountPaid
                                      : styles.pending
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Grid>
          ))
      ) : (
        <div className={styles.noJobsStyle}>
          <Typography
            variant="h6"
            className={`${styles.noJobsBox} ${styles.noJobsText}`}
          >
            No batches available
          </Typography>
        </div>
      )}
      {openModalToUpdateBatch && (
        <ModalToUpdateBatches
          openModal={openModalToUpdateBatch}
          setOpenModalToUpdateBatch={setOpenModalToUpdateBatch}
          batch={detailsOfBatchSelected}
        />
      )}
    </Grid>
  );
};

export default Completed;
